import React, { useState } from "react";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";
import { DF_LO0021Context } from "./context";
import GridHeader from "./Grid/GridHeader";
import GridBody from "./Grid/GridBody";
import withRouter from "../../../components/Common/withRouter";

const DF_LO0021 = (props) => {
  console.log("🤖 %cTransação [DF_LO0021 - Criar Rota]", "color:green");

  const { userProfile, isModalPage } = useSelector((state) => ({
    userProfile: state.login.profile,
    isModalPage: state.Layout.isModalPage,
  }));

  const { navigate, location, params } = props.router;
  const [isLoading, setIsLoading] = useState(false);

  return (
    <React.Fragment>
      <DF_LO0021Context.Provider
        value={{
          isLoading,
          setIsLoading,
          userProfile,
          navigate,
          location,
          params,
        }}
      >
        <div
          style={{
            padding: isModalPage && "0px",
            overflow: isModalPage && "hidden",
          }}
          className="page-content"
        >
          <Container fluid={true} className="dataTable-custom-primary" style={isModalPage ? { padding: "20px 24px" } : {}}>
            <GridHeader />
            <GridBody />
          </Container>
        </div>
      </DF_LO0021Context.Provider>
    </React.Fragment>
  );
};

export default withRouter(DF_LO0021);